import type { StepConfig } from '@/types/onboarding';

/**
 * Individual DSA/Connector — Finalized flow (Steps 0-10)
 *
 * Step 0: Welcome (public, outside progress bar)
 * Step 1: OTP Login (public, outside progress bar)
 * Step 2: Entity Type Selection
 * Step 3: Aadhaar eKYC (auto-fills basic details & address)
 * Step 4: Basic Details (auto-filled from Aadhaar — name/DOB/gender read-only)
 * Step 5: Address (permanent pre-filled from Aadhaar, current manual)
 * Step 6: PAN Verification
 * Step 7: Bank Account Verification
 * Step 8: GST Details (OPTIONAL — can be skipped)
 * Step 9: Live Photo
 * Step 10: MOU Preview + Aadhaar eSign → Success
 */
export const individualSteps: StepConfig[] = [
  { id: 'entity-type', path: '/entity-type', label: 'Entity Type', shortLabel: 'Entity', applicableTo: ['individual'], isRequired: true },
  { id: 'aadhaar-kyc', path: '/aadhaar-kyc', label: 'Aadhaar eKYC', shortLabel: 'Aadhaar', applicableTo: ['individual'], isRequired: true },
  { id: 'basic-details', path: '/basic-details', label: 'Basic Details', shortLabel: 'Details', applicableTo: ['individual'], isRequired: true },
  { id: 'address', path: '/address', label: 'Address', shortLabel: 'Address', applicableTo: ['individual'], isRequired: true },
  { id: 'pan-verification', path: '/pan-verification', label: 'PAN Verification', shortLabel: 'PAN', applicableTo: ['individual'], isRequired: true },
  { id: 'bank-verification', path: '/bank-verification', label: 'Bank Account', shortLabel: 'Bank', applicableTo: ['individual'], isRequired: true },
  { id: 'gstin', path: '/gstin', label: 'GST Details', shortLabel: 'GST', applicableTo: ['individual'], isRequired: false },
  { id: 'live-photo', path: '/live-photo', label: 'Live Photo', shortLabel: 'Photo', applicableTo: ['individual'], isRequired: true },
  { id: 'mou-preview', path: '/mou-preview', label: 'Review & Sign', shortLabel: 'MOU', applicableTo: ['individual'], isRequired: true },
  { id: 'esign', path: '/esign', label: 'eSign', shortLabel: 'eSign', applicableTo: ['individual'], isRequired: true },
  { id: 'success', path: '/success', label: 'Success', shortLabel: 'Done', applicableTo: ['individual'], isRequired: true },
];
